// extracted by mini-css-extract-plugin
export default {"container":"TN-z","modal":"UN-z","dimensions":"VN-z","brandName":"WN-z","productName":"XN-z","recipientEmail":"YN-z","recommendedFit":"ZN-z","hiddenField":"_N-z"};